export default __webpack_public_path__ + "static/appdynamics-logo-062bb3f6a86a887b80c2d0f0ada1f0e5.png";